import React from 'react'
import { List, MinimalistTitle } from '@wallyhealth/web-core'
import styles from './index.module.css'

const SafetySection = () => (
  <div className={styles.container}>
    <MinimalistTitle
      className={styles.title}
      title="Safety"
    />
    <List
      className={styles.list}
      items={[
        {
          label: 'Do not swallow the gel, avoid eye contact with the gel, and avoid direct contact with your gums with the gel.',
          icon: (
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4258 11.3945L31.1943 6.19727L35 12.251L25.1064 17.5L35 22.749L31.1943 28.8027L21.4258 23.6055V35H13.5752V23.6055L3.80566 28.8027L0 22.7471L9.89258 17.498L0 12.251L3.80566 6.19727L13.5752 11.3945V0H21.4258V11.3945Z" fill="black"/>
            </svg>
          )
        },
        {
          label: 'If you experience gum sensitivity, remove your trays and discontinue use.',
          icon: (
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4258 11.3945L31.1943 6.19727L35 12.251L25.1064 17.5L35 22.749L31.1943 28.8027L21.4258 23.6055V35H13.5752V23.6055L3.80566 28.8027L0 22.7471L9.89258 17.498L0 12.251L3.80566 6.19727L13.5752 11.3945V0H21.4258V11.3945Z" fill="black"/>
            </svg>
          )
        },
        {
          label: 'Product is not recommended for use by children under 16 years of age.',
          icon: (
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4258 11.3945L31.1943 6.19727L35 12.251L25.1064 17.5L35 22.749L31.1943 28.8027L21.4258 23.6055V35H13.5752V23.6055L3.80566 28.8027L0 22.7471L9.89258 17.498L0 12.251L3.80566 6.19727L13.5752 11.3945V0H21.4258V11.3945Z" fill="black"/>
            </svg>
          )
        },
        {
          label: 'Follow your Wally clinicians\' recommendations to ensure continued safety.',
          icon: (
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4258 11.3945L31.1943 6.19727L35 12.251L25.1064 17.5L35 22.749L31.1943 28.8027L21.4258 23.6055V35H13.5752V23.6055L3.80566 28.8027L0 22.7471L9.89258 17.498L0 12.251L3.80566 6.19727L13.5752 11.3945V0H21.4258V11.3945Z" fill="black"/>
            </svg>
          )
        },
        {
          label: 'Do not use if you are pregnant, lactating, or think you might be pregnant as safety has not been FDA approved in these instances.',
          icon: (
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4258 11.3945L31.1943 6.19727L35 12.251L25.1064 17.5L35 22.749L31.1943 28.8027L21.4258 23.6055V35H13.5752V23.6055L3.80566 28.8027L0 22.7471L9.89258 17.498L0 12.251L3.80566 6.19727L13.5752 11.3945V0H21.4258V11.3945Z" fill="black"/>
            </svg>
          )
        },
        {
          label: 'If you have any questions or concerns, reach out to your Care Team.',
          icon: (
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4258 11.3945L31.1943 6.19727L35 12.251L25.1064 17.5L35 22.749L31.1943 28.8027L21.4258 23.6055V35H13.5752V23.6055L3.80566 28.8027L0 22.7471L9.89258 17.498L0 12.251L3.80566 6.19727L13.5752 11.3945V0H21.4258V11.3945Z" fill="black"/>
            </svg>
          )
        }
      ]}
    />
  </div>
)

export default SafetySection
